import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { Buttton, CustomDatePicker, Inputs, SelectO } from "..";
import { useDispatch, useSelector } from "react-redux";
import { actionDoctor, actionPatient } from "../../redux/actions";
import { useTranslation } from "react-i18next";
import { FaCaretRight } from "react-icons/fa";
import { useAlert, useToast } from "../../contexts";
import { ViewAllAvailability } from ".";

const AddAppointmentModal = ({
    show,
    onHide,
    size,
    centered,
    className,
    backdrop,
    bodyContent1,
    loginData,
}) => {
    const { t } = useTranslation();
    const options = [
        { value: "false", label: t("exado_user") },
        { value: "true", label: t("external_user") },
    ];
    const dispatch = useDispatch();
    const { showAlert } = useAlert();
    const { showToast } = useToast();
    const [selectedUserType, setSelectedUserType] = useState(null);
    const [options1, setOptions1] = useState([]);
    const [options2, setOptions2] = useState([]);
    const [options3, setOptions3] = useState([]);
    const [selectedOptions1, setSelectedOptions1] = useState(null);
    const [selectedOptions2, setSelectedOptions2] = useState(null);
    const [selectedOptions3, setSelectedOptions3] = useState(null);
    const [appointmentDate, setAppointmentDate] = useState();
    const [showModal, setShowModal] = useState(false);
    const [isAllAvailability, setIsAllAvailability] = useState(false);
    const [credentials, setCredentials] = useState({
        patientfirstname: "",
        patientlastname: "",
        gender: "male",
        email: "",
        phone: "",
        PatientGuid: "00000000-0000-0000-0000-000000000000",
        doctorGuid: "00000000-0000-0000-0000-000000000000",
        appointmentType: 2,
        symptoms: "",
        sinceWhen: "",
        anyMedication: "",
        diagnosisGiven: "",
        appointmentDate: "",
        TimeZoneGuid: loginData?.timezoneGuid,
        Currency: loginData?.currencyCode,
        AppointmentTimeZone: loginData?.timeZoneId,
        AppointmentCurrency: loginData?.currencyCode,
        AppointmentDuration: null,
        ClinicGuid: null,
        IsClinicSchedule: false,
        consultFees: null,
        appointmentStatus: 2,
        socialSecurityNumber: "",
        address: "",
    });

    const [credentials1, setCredentials1] = useState({
        appDate: "",
        appointmentType: 2,
        userTimeZone: loginData?.timeZoneId,
        currency: loginData?.currencyCode,
        clinicGuid: null,
        IsClinicSchedule:
            selectedOptions2?.value === loginData?.userGuid ? false : true,
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        setCredentials1((prev) => ({
            ...prev,
            clinicGuid:
                selectedOptions2?.value === loginData?.userGuid
                    ? null
                    : loginData?.clinicGuid,
            IsClinicSchedule:
                selectedOptions2?.value === loginData?.userGuid ? false : true,
        }));
    }, [loginData?.clinicGuid, loginData?.userGuid, selectedOptions2?.value]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    const handleDateChange = (date, allavailability) => {
        if (allavailability) {
            setIsAllAvailability(allavailability);
        }

        if (date) {
            const selectedDate = new Date(date);

            if (isNaN(selectedDate.getTime())) {
                console.error("Invalid date passed to handleDateChange:", date);
                return;
            }

            setAppointmentDate(selectedDate);
            const localDate = new Date(
                selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000
            );
            const year = localDate.getFullYear();
            const month = String(localDate.getMonth() + 1).padStart(2, "0");
            const day = String(localDate.getDate()).padStart(2, "0");
            const formattedDate = `${year}-${month}-${day}`;

            setCredentials1((prev) => ({
                ...prev,
                appDate: formattedDate,
            }));

            setSelectedOptions3();
            setOptions3([]);
        }
    };

    useEffect(() => {
        if (credentials1.appDate) {
            dispatch(
                actionPatient.postAllAvailability(credentials1, selectedOptions2?.value)
            );
        }
    }, [credentials1, credentials1.appDate, dispatch, selectedOptions2?.value]);
    const getSelectedUserDetailsData = useSelector(
        (state) => state.patient.getSelectedUserDetailsData?.data
    );
    const postAllAvailabilityData = useSelector(
        (state) => state.patient.postAllAvailabilityData?.data
    );
    useEffect(() => {
        if (getSelectedUserDetailsData?.success) {
            setCredentials((prev) => ({
                ...prev,
                patientfirstname: getSelectedUserDetailsData?.result?.firstName,
                patientlastname: getSelectedUserDetailsData?.result?.lastName,
                gender:
                    getSelectedUserDetailsData?.result?.gender === 1
                        ? "male"
                        : getSelectedUserDetailsData?.result?.gender === 2
                            ? "female"
                            : "other",
                email: getSelectedUserDetailsData?.result?.email,
                phone: getSelectedUserDetailsData?.result?.phone,
            }));
        }
    }, [getSelectedUserDetailsData]);

    useEffect(() => {
        if (postAllAvailabilityData) {
            setCredentials((prev) => ({
                ...prev,
                consultFees: Number(
                    postAllAvailabilityData?.result?.inclinicAppointmentFees?.replace(
                        /[,]+/g,
                        ""
                    )
                ),
                AppointmentDuration:
                    postAllAvailabilityData?.result?.appoinmentDuration,
            }));

            const selectedDateData =
                postAllAvailabilityData?.result?.availableSlots.find(
                    (item) => item.currentDate.split("T")[0] === credentials1.appDate
                );

            if (selectedDateData) {
                const newOptions = selectedDateData.availableTime.map((time) => ({
                    value: time,
                    label: new Date(time).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                    }),
                }));

                setOptions3(newOptions);

                if (isAllAvailability && appointmentDate) {
                    const matched = newOptions.find((opt) => {
                        const a = new Date(opt.value).getTime();
                        const b = new Date(appointmentDate).getTime();
                        return a === b;
                    });

                    if (matched) {
                        setSelectedOptions3(matched);
                        setCredentials((prev) => ({
                            ...prev,
                            appointmentDate: matched.value,
                        }));
                    }

                    setIsAllAvailability(false);
                }
            }
        }
    }, [
        postAllAvailabilityData,
        credentials1.appDate,
        isAllAvailability,
        appointmentDate,
    ]);

    useEffect(() => {
        dispatch(actionDoctor.getClinicDoctorDetails(loginData.clinicGuid));
    }, [dispatch, loginData.clinicGuid, selectedUserType]);

    useEffect(() => {
        if (!selectedUserType) return;

        dispatch(
            actionPatient.getUserTypeAppointment(
                loginData?.userGuid,
                selectedUserType?.value
            )
        );
    }, [dispatch, loginData.clinicGuid, loginData?.userGuid, selectedUserType]);

    const getUserTypeAppointmentData = useSelector(
        (state) => state.patient.getUserTypeAppointmentData?.data
    );

    const getClinicDoctorDetailsData = useSelector(
        (state) => state.doctor.getClinicDoctorDetailsData?.data
    );
    useEffect(() => {
        if (getClinicDoctorDetailsData) {
            const newOption = getClinicDoctorDetailsData.result.doctorLists.map(
                (item) => ({
                    value: item.doctorGuid,
                    label: item.doctorName,
                })
            );
            setOptions2(newOption);
            const defaultOption = newOption.find(
                (item) => item.value === loginData.userGuid
            );

            if (defaultOption) {
                setSelectedOptions2(defaultOption);
                setCredentials((prev) => ({
                    ...prev,
                    doctorGuid: defaultOption.value,
                }));
            }
        }
    }, [getClinicDoctorDetailsData, loginData]);

    useEffect(() => {
        if (getUserTypeAppointmentData?.result?.length > 0) {
            const uniquePatients = Array.from(
                new Map(
                    getUserTypeAppointmentData.result.map((item) => [item.userGuid, item])
                ).values()
            );

            const patientsOptions = uniquePatients.map((item) => ({
                value: item.userGuid,
                label: item.userName,
            }));

            setOptions1(patientsOptions);
        }
    }, [getUserTypeAppointmentData]);

    const handleSave = () => {
        let newErrors = {};

        if (!selectedUserType) {
            newErrors.selectedUserType = "Please select a patient type.";
        }

        if (selectedUserType?.value === "false" && !selectedOptions1) {
            newErrors.selectedOptions1 = "Please select a patient.";
        }

        if (!selectedOptions2) {
            newErrors.selectedOptions2 = "Please select a doctor.";
        }

        if (!credentials.patientfirstname.trim()) {
            newErrors.patientfirstname = "First name is required.";
        }

        if (!credentials.patientlastname.trim()) {
            newErrors.patientlastname = "Last name is required.";
        }

        if (!credentials.address.trim()) {
            newErrors.address = "Address is required.";
        } else if (credentials.address.length < 10) {
            newErrors.address = "Address must be at least 10 characters long.";
        } else if (credentials.address.length > 200) {
            newErrors.address = "Address must be no more than 200 characters.";
        }

        if (!credentials.email.trim()) {
            newErrors.email = "Email is required.";
        } else if (!/\S+@\S+\.\S+/.test(credentials.email)) {
            newErrors.email = "Enter a valid email address.";
        }

        if (!credentials.phone) {
            newErrors.phone = t("errors.phone.error1");
        } else if (!/^\d+$/.test(credentials.phone)) {
            newErrors.phone = t("errors.phone.error2");
        }

        if (!selectedOptions3) {
            newErrors.selectedOptions3 = "Please select a slot.";
        }

        if (!credentials.symptoms.trim()) {
            newErrors.symptoms = "Symptoms description is required.";
        } else if (credentials.symptoms.length < 10) {
            newErrors.symptoms = "Symptoms must be at least 10 characters long.";
        } else if (credentials.symptoms.length > 200) {
            newErrors.symptoms = "Symptoms must be no more than 200 characters.";
        }

        if (!credentials.sinceWhen.trim()) {
            newErrors.sinceWhen = "This field is required.";
        } else if (!/^\d+$/.test(credentials.sinceWhen)) {
            newErrors.sinceWhen = "Only numeric values are allowed.";
        } else if (parseInt(credentials.sinceWhen, 10) < 1) {
            newErrors.sinceWhen = "Value must be greater than 0.";
        }

        if (!credentials.anyMedication.trim()) {
            newErrors.anyMedication = "This field is required.";
        } else if (credentials.anyMedication.length < 1) {
            newErrors.anyMedication =
                "Medication details must be at least 3 characters long.";
        } else if (credentials.anyMedication.length > 200) {
            newErrors.anyMedication =
                "Medication details must be no more than 200 characters.";
        }

        if (!credentials.diagnosisGiven.trim()) {
            newErrors.diagnosisGiven = "This field is required.";
        } else if (credentials.diagnosisGiven.length < 1) {
            newErrors.diagnosisGiven =
                "Diagnosis details must be at least 3 characters long.";
        } else if (credentials.diagnosisGiven.length > 200) {
            newErrors.diagnosisGiven =
                "Diagnosis details must be no more than 200 characters.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        dispatch(
            actionPatient.postBookOfflineAppointment(
                credentials,
                (error, response) => {
                    if (error) {
                        if (error.data) {
                            if (error.data.statusCode === 400) {
                                if (error.data.error && error.data.error.ValidationErrors) {
                                    error.data.error.ValidationErrors.forEach(
                                        (validationError) => {
                                            console.error(
                                                `${t("Field")}: ${validationError.Field} - ${t(
                                                    "Message"
                                                )}: ${validationError.Message}`
                                            );

                                            showAlert(
                                                "danger",
                                                validationError.Message,
                                                `${t("Error")} : ${validationError.Field}`
                                            );
                                        }
                                    );
                                } else {
                                    showAlert(
                                        "danger",
                                        t("Invalid_credentials"),
                                        `${t("Error")} !`
                                    );
                                }
                            } else {
                                showAlert("danger", t("unexpected_error"), `${t("Error")} !`);
                            }
                        }
                    } else if (response) {
                        if (response.status === 200) {
                            showToast(
                                t("success"),
                                t("doctor.add_appointment.offline_appointment_booked"),
                                5000,
                                true,
                                "top-end toast-success"
                            );

                            dispatch(
                                actionPatient.getAppointments(
                                    10,
                                    1,
                                    "",
                                    "",
                                    "",
                                    "",
                                    loginData.userGuid,
                                    2,
                                    "",
                                    "",
                                    null,
                                    null,
                                    loginData?.currencyCode,
                                    loginData.timeZoneId,
                                    null,
                                    null,
                                    null,
                                    loginData?.languageId,
                                    [1, 2, 3],
                                    null
                                )
                            );
                            onHide();
                        }
                    }
                }
            )
        );
        setCredentials({
            ...credentials,
            patientfirstname: "",
            patientlastname: "",
            email: "",
            phone: "",
            symptoms: "",
            sinceWhen: "",
            nyMedication: "",
            diagnosisGiven: "",
            socialSecurityNumber: "",
            address: "",
        });
        setAppointmentDate();
    };
    return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                size={size}
                aria-labelledby="contained-modal-title-vcenter"
                centered={centered}
                className="input-modal addAppointment-modal"
                backdrop={backdrop}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2 className="exado-title-nine">{t("book_an_appointment")}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form className="addApp-modal">
                        <Row className="add-row">
                            <Form.Label className="exado-title-six add-lable">
                                {t("visiting_schedule.select_appointment_type")}
                            </Form.Label>
                            <Col>
                                <SelectO.SelectO
                                    options={options}
                                    onChange={(selected) => {
                                        setSelectedUserType(selected);
                                        setErrors((prevErrors) => ({
                                            ...prevErrors,
                                            selectedUserType: "",
                                        }));
                                    }}
                                    isSearchable={false}
                                    name="userType"
                                    value={selectedUserType}
                                    className={`select1 ${errors.selectedUserType ? "select-border-error" : ""
                                        }`}
                                    placeholder={t("patient_type")}
                                />
                                {errors.selectedUserType && (
                                    <Form.Text className="error-message noVerify">
                                        {errors.selectedUserType}
                                    </Form.Text>
                                )}
                            </Col>

                            <Col>
                                <SelectO.SelectO
                                    options={options1}
                                    onChange={(selected) => {
                                        setSelectedOptions1(selected);
                                        if (selected) {
                                            dispatch(
                                                actionPatient.getSelectedUserDetails(selected?.value)
                                            );
                                            setCredentials({
                                                ...credentials,
                                                PatientGuid: selected?.value,
                                            });
                                        }

                                        setErrors((prevErrors) => ({
                                            ...prevErrors,
                                            selectedOptions1: "",
                                        }));
                                    }}
                                    name="user"
                                    className={`select1 ${errors.selectedOptions1 ? "select-border-error" : ""
                                        }`}
                                    // className="select1"
                                    value={selectedOptions1}
                                    isDisabled={!selectedUserType}
                                    placeholder={t("select_patient")}
                                />
                                {errors.selectedOptions1 && (
                                    <Form.Text className="error-message noVerify">
                                        {errors.selectedOptions1}
                                    </Form.Text>
                                )}
                            </Col>
                            <Col>
                                <SelectO.SelectO
                                    options={options2}
                                    onChange={(selected) => {
                                        setSelectedOptions2(selected);
                                        setErrors((prevErrors) => ({
                                            ...prevErrors,
                                            selectedOptions2: "",
                                        }));
                                    }}
                                    isSearchable={false}
                                    name="doctor"
                                    value={selectedOptions2}
                                    className={`select1 ${errors.selectedOptions2 ? "select-border-error" : ""
                                        }`}
                                    placeholder={t("Select") + " " + t("doctor")}
                                />
                                {errors.selectedOptions2 && (
                                    <Form.Text className="error-message noVerify">
                                        {errors.selectedOptions2}
                                    </Form.Text>
                                )}
                            </Col>
                        </Row>
                        <Row className="add-row">
                            <Form.Label className="exado-title-six add-lable">
                                {t("doctor.diagnostic_report.patient_personal_information")}
                            </Form.Label>

                            <Col md={6} className="add-col">
                                <Row>
                                    <Inputs.FormInputs
                                        label={
                                            errors.patientfirstname ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.patientfirstname}
                                                </span>
                                            ) : (
                                                t("first_name")
                                            )
                                        }
                                        name="patientfirstname"
                                        value={credentials.patientfirstname}
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.patientfirstname ? "form-group-error" : ""
                                            }`}
                                    // disabled={!isEditVisible}
                                    />
                                </Row>
                            </Col>
                            <Col md={6} className="add-col">
                                <Row>
                                    <Inputs.FormInputs
                                        label={
                                            errors.patientlastname ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.patientlastname}
                                                </span>
                                            ) : (
                                                t("last_name")
                                            )
                                        }
                                        name="patientlastname"
                                        value={credentials.patientlastname}
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.patientlastname ? "form-group-error" : ""
                                            }`}
                                    // disabled={!isEditVisible}
                                    />
                                </Row>
                            </Col>

                            <Col md={6}>
                                <Row>
                                    <Inputs.FormInputs
                                        label={
                                            errors.socialSecurityNumber ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.socialSecurityNumber}
                                                </span>
                                            ) : (
                                                "socialSecurityNumber"
                                            )
                                        }
                                        name="socialSecurityNumber"
                                        value={credentials.socialSecurityNumber}
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.socialSecurityNumber ? "form-group-error" : ""
                                            }`}
                                    // disabled={!isEditVisible}
                                    />
                                </Row>
                            </Col>

                            <Col md={6}>
                                <Row>
                                    <Inputs.FormInputs
                                        label={
                                            errors.address ? (
                                                <span className="error-message"> {errors.address}</span>
                                            ) : (
                                                t("Address")
                                            )
                                        }
                                        name="address"
                                        value={credentials.address}
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.address ? "form-group-error" : ""
                                            }`}
                                    // disabled={!isEditVisible}
                                    />
                                </Row>
                            </Col>
                        </Row>
                        <Row className="add-row">
                            <Form.Label className="exado-title-six add-lable">
                                {t("Gender")}
                            </Form.Label>
                            <Col className="form-grp-radio-col">
                                <Inputs.CheckRadioInput
                                    type="radio"
                                    label={t("Female")}
                                    name="gender"
                                    className="form-grp-radio"
                                    checked={credentials.gender === "female"}
                                    onChange={() =>
                                        setCredentials({ ...credentials, gender: "female" })
                                    }
                                // disabled={!isEditVisible}
                                />
                                <Inputs.CheckRadioInput
                                    type="radio"
                                    label={t("Male")}
                                    name="gender"
                                    className="form-grp-radio"
                                    checked={credentials.gender === "male"}
                                    onChange={() =>
                                        setCredentials({ ...credentials, gender: "male" })
                                    }
                                // disabled={!isEditVisible}
                                />
                                <Inputs.CheckRadioInput
                                    type="radio"
                                    label={t("Other")}
                                    name="gender"
                                    className="form-grp-radio"
                                    checked={credentials.gender === "other"}
                                    onChange={() =>
                                        setCredentials({ ...credentials, gender: "other" })
                                    }
                                // disabled={!isEditVisible}
                                />
                            </Col>
                        </Row>
                        <Row className="add-row">
                            <Form.Label className="exado-title-six add-lable">
                                {t("doctor.diagnostic_report.patient_contact_information")}
                            </Form.Label>
                            <Col>
                                <Row>
                                    <Inputs.FormInputs
                                        label={
                                            errors.email ? (
                                                <span className="error-message"> {errors.email}</span>
                                            ) : (
                                                `${t("email")} ${t("Address")}`
                                            )
                                        }
                                        name="email"
                                        value={credentials.email}
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.email ? "form-group-error" : ""
                                            }`}
                                    // disabled={!isEditVisible}
                                    />
                                </Row>
                            </Col>
                            <Col>
                                <Row>
                                    <Inputs.FormInputs
                                        label={
                                            errors.phone ? (
                                                <span className="error-message"> {errors.phone}</span>
                                            ) : (
                                                t("phone_number")
                                            )
                                        }
                                        name="phone"
                                        value={credentials.phone}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, "");
                                            setCredentials({ ...credentials, phone: value });
                                        }}
                                        grpClassname={`form-group ${errors.phone ? "form-group-error" : ""
                                            }`}

                                    // disabled={!isEditVisible}
                                    />
                                </Row>
                            </Col>
                        </Row>
                        <Row className="add-row">
                            <Form.Label className="exado-title-six add-lable">
                                {t("appointment_time")}
                            </Form.Label>
                            <Col md={4} className="add-col">
                                <fieldset
                                    className={`frm-fieldset custom-date-picker ${errors.doB ? "error-date" : ""
                                        }`}
                                >
                                    <legend className="frm-legend">
                                        {errors.doB ? (
                                            <span className="error-message">{errors.doB}</span>
                                        ) : (
                                            t("date")
                                        )}
                                    </legend>

                                    <CustomDatePicker.CustomDatePickerDMY
                                        selected={appointmentDate}
                                        onChange={handleDateChange}
                                        placeholderText="DD - MM - YYYY"
                                        dateFormat="dd-MM-yyyy"
                                        className="customDatePicker"
                                        minDate={new Date()}
                                    />
                                </fieldset>
                            </Col>
                            <Col md={4} className="mt-auto add-col">
                                <SelectO.SelectO
                                    options={options3}
                                    onChange={(selected) => {
                                        setSelectedOptions3(selected);
                                        setCredentials((prevCredentials) => ({
                                            ...prevCredentials,
                                            appointmentDate: selected.value,
                                        }));
                                        setErrors((prevErrors) => ({
                                            ...prevErrors,
                                            selectedOptions3: "",
                                        }));
                                    }}
                                    isSearchable={false}
                                    name="appointmentTime"
                                    value={selectedOptions3}
                                    className={`select1 ${errors.selectedOptions3 ? "select-border-error" : ""
                                        }`}
                                    placeholder={t("select_time_slot")}
                                    isDisabled={!appointmentDate}
                                />
                                {errors.selectedOptions3 && (
                                    <Form.Text className="error-message noVerify">
                                        {errors.selectedOptions3}
                                    </Form.Text>
                                )}
                            </Col>
                            <Col md={6}>
                                <Buttton.Buttton
                                    type="button"
                                    className="transparent ms-auto"
                                    onClick={() => {
                                        setShowModal(true);

                                        const today = new Date();
                                        const localDate = new Date(
                                            today.getTime() - today.getTimezoneOffset() * 60000
                                        );
                                        const year = localDate.getFullYear();
                                        const month = String(localDate.getMonth() + 1).padStart(
                                            2,
                                            "0"
                                        );
                                        const day = String(localDate.getDate()).padStart(2, "0");
                                        const formattedDate = `${year}-${month}-${day}`;

                                        setCredentials1((prev) => ({
                                            ...prev,
                                            appDate: formattedDate,
                                        }));
                                    }}
                                >
                                    {t("view_avaiability")} <FaCaretRight />
                                </Buttton.Buttton>
                            </Col>
                        </Row>
                        <Row className="add-row">
                            <Form.Label className="exado-title-six add-lable">
                                {t("doctor.add_appointment.illness_information")}
                            </Form.Label>
                            <Col md={12} className="add-col">
                                <Row>
                                    <Inputs.FormInputs
                                        placeholder="Write text here"
                                        label={
                                            errors.symptoms ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.symptoms}
                                                </span>
                                            ) : (
                                                t("doctor.add_appointment.symptoms_description")
                                            )
                                        }
                                        name="symptoms"
                                        value={credentials.symptoms}
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.symptoms ? "form-group-error" : ""
                                            }`}
                                    // disabled={!isEditVisible}
                                    />
                                </Row>
                            </Col>
                            <Col md={12} className="add-col">
                                <Row>
                                    <Inputs.FormInputs
                                        placeholder="Write text here"
                                        label={
                                            errors.sinceWhen ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.sinceWhen}
                                                </span>
                                            ) : (
                                                t("doctor.add_appointment.symptoms_duration")
                                            )
                                        }
                                        name="sinceWhen"
                                        value={credentials.sinceWhen}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, "");
                                            setCredentials({ ...credentials, sinceWhen: value });
                                            if (value) {
                                                setErrors((prevErrors) => ({
                                                    ...prevErrors,
                                                    sinceWhen: "",
                                                }));
                                            }
                                        }}
                                        grpClassname={`form-group ${errors.sinceWhen ? "form-group-error" : ""
                                            }`}
                                    // disabled={!isEditVisible}
                                    />
                                </Row>
                            </Col>
                            <Col md={12} className="add-col">
                                <Row>
                                    <Inputs.FormInputs
                                        placeholder="Write text here"
                                        label={
                                            errors.anyMedication ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.anyMedication}
                                                </span>
                                            ) : (
                                                t("doctor.add_appointment.medication_taken")
                                            )
                                        }
                                        name="anyMedication"
                                        value={credentials.anyMedication}
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.anyMedication ? "form-group-error" : ""
                                            }`}
                                    // disabled={!isEditVisible}
                                    />
                                </Row>
                            </Col>
                            <Col md={12} className="add-col">
                                <Row>
                                    <Inputs.FormInputs
                                        placeholder="Write text here"
                                        label={
                                            errors.diagnosisGiven ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.diagnosisGiven}
                                                </span>
                                            ) : (
                                                t("doctor.add_appointment.diagnosis_given")
                                            )
                                        }
                                        name="diagnosisGiven"
                                        value={credentials.diagnosisGiven}
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.diagnosisGiven ? "form-group-error" : ""
                                            }`}
                                    // disabled={!isEditVisible}
                                    />
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                    {bodyContent1}
                </Modal.Body>
                <Modal.Footer>
                    <Buttton.Buttton
                        children={t("CANCEL")}
                        className="btn-border-Aqua_Teal"
                        onClick={() => onHide()}
                    />
                    <Buttton.Buttton
                        children={t("Save")}
                        className="btn-solid-Aqua_Teal"
                        onClick={handleSave}
                    />
                </Modal.Footer>
            </Modal>
            <ViewAllAvailability
                show={showModal}
                onHide={() => setShowModal(false)}
                credentials1={credentials1}
                selectedOptions2={selectedOptions2}
                loginData={loginData}
                handleDateChange={handleDateChange}
            />
        </>
    );
};

export default AddAppointmentModal;
